import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCookie } from '../../helpers/cookies';
var DEFAULT_ANALYTICS_DEBOUNCE_DELAY_MS = 2000;
var ANALYTICS_DEBOUNCE_DELAY_COOKIE = 'analytics_debounce_delay';
var analyticsUpdateTimeout;
var isAnalyticsDebounceEnabled = false;
var trackQueue = [];
function getAnalyticsDebounceDelay() {
  if (typeof window === 'undefined') {
    return DEFAULT_ANALYTICS_DEBOUNCE_DELAY_MS;
  }
  var rawDelay = getCookie(ANALYTICS_DEBOUNCE_DELAY_COOKIE);
  var parsedDelay = Number(rawDelay);
  if (!Number.isFinite(parsedDelay) || parsedDelay < 0) {
    return DEFAULT_ANALYTICS_DEBOUNCE_DELAY_MS;
  }
  return parsedDelay;
}
var analyticsDebounceDelay = getAnalyticsDebounceDelay();
export function configureAnalytics(options) {
  var _options$isAnalyticsD;
  isAnalyticsDebounceEnabled = (_options$isAnalyticsD = options.isAnalyticsDebounceEnabled) !== null && _options$isAnalyticsD !== void 0 ? _options$isAnalyticsD : false;
}
function flushTrackQueue() {
  if (typeof window !== 'undefined' && window._satellite) {
    trackQueue.forEach(_ref => {
      var eventName = _ref.eventName,
        payload = _ref.payload;
      if (!payload) {
        window._satellite.track(eventName);
      } else {
        window._satellite.track(eventName, payload);
      }
    });
  }
  trackQueue = [];
}
function triggerAnalyticsUpdatedDebounced() {
  if (!isAnalyticsDebounceEnabled) {
    return;
  }
  if (typeof window !== 'undefined') {
    if (analyticsUpdateTimeout) {
      clearTimeout(analyticsUpdateTimeout);
    }
    analyticsUpdateTimeout = window.setTimeout(() => {
      analyticsUpdateTimeout = undefined;
      flushTrackQueue();
      if (window._satellite) {
        window._satellite.track('analyticsData_updated', window.analyticsData);
      }
    }, analyticsDebounceDelay);
  }
}
var analytics = {
  update: payload => {
    window.analyticsData = _objectSpread(_objectSpread({}, window.analyticsData), payload);
    triggerAnalyticsUpdatedDebounced();
  },
  updateEncodedAnalytics: payload => {
    window.rdata = payload !== null && payload !== void 0 ? payload : [];
  },
  remove: payload => {
    payload.forEach(item => {
      if (Object.keys(window.analyticsData).includes(item)) {
        delete window.analyticsData[item];
      }
    });
    triggerAnalyticsUpdatedDebounced();
  },
  track: (eventName, payload, waitForUpdates) => {
    if (waitForUpdates && isAnalyticsDebounceEnabled && analyticsUpdateTimeout) {
      trackQueue.push({
        eventName,
        payload
      });
      return;
    }
    if (typeof window !== 'undefined' && window._satellite) {
      if (!payload) {
        window._satellite.track(eventName);
        return;
      }
      window._satellite.track(eventName, payload);
    }
  }
};
export var restaurantFormAnalytics = {
  update: payload => {
    window.analyticsData.restaurants = _objectSpread(_objectSpread({}, window.analyticsData.restaurants), payload);
    triggerAnalyticsUpdatedDebounced();
  }
};
export var analyticsConfirmation = {
  update: payload => {
    window.analyticsDataCartConfirmation = _objectSpread(_objectSpread({}, window.analyticsDataCartConfirmation), payload);
    triggerAnalyticsUpdatedDebounced();
  }
};
export var timeTrackerSeconds = () => {
  var beforeTime = new Date();
  return () => {
    var nowTime = new Date();
    return ((nowTime - beforeTime) / 1000).toString();
  };
};
export var analyticsTrackings = function (analyticsTrackings) {
  analyticsTrackings["HOTEL"] = "Hotel";
  analyticsTrackings["DATE"] = "Date";
  analyticsTrackings["FOOD"] = "Food";
  analyticsTrackings["ADDON"] = "Addon";
  analyticsTrackings["RATE_PLAN"] = "ratePlan";
  return analyticsTrackings;
}({});
export default analytics;